<p-toolbar styleClass="">
  <ng-template pTemplate="left">
    <p-button label="Получить актуальные на сайте НБУ" icon="pi pi-dollar" styleClass="p-button-success mr-2" (onClick)="onGetExtApiRate1($event)"
              [disabled]="true" pTooltip="Получить актуальные курсы на сайте НБУ" tooltipPosition="top"></p-button>

    <p-button label="Получить архив на сайте НБУ" icon="pi pi-chart-line" styleClass="p-button-success mr-2" (onClick)="onGetExtApiRate2($event)"
              [disabled]="loading" pTooltip="Получить архив курсов на сайте НБУ" tooltipPosition="top"></p-button>

    <p-button label="Получить актуальные на сайте Минфин" icon="pi pi-euro" styleClass="p-button-success mr-2" (onClick)="onGetExtApiRate3($event)"
              [disabled]="loading" pTooltip="Получить актуальные курсы на сайте Минфин" tooltipPosition="top"></p-button>

    <p-button label="Получить актуальные на сайте ERC" icon="pi pi-euro" styleClass="p-button-success mr-2" (onClick)="onGetExtApiRate4($event)"
              [disabled]="false" pTooltip="Получить актуальные курсы на сайте ERC" tooltipPosition="top"></p-button>
  </ng-template>
</p-toolbar>
<textarea [rows]="15" pInputTextarea [(ngModel)]="logRows" [autoResize]="true"></textarea>
